import { render, staticRenderFns } from "./AppNoRecordScreen.vue?vue&type=template&id=51046a1e&scoped=true"
import script from "./AppNoRecordScreen.vue?vue&type=script&lang=js"
export * from "./AppNoRecordScreen.vue?vue&type=script&lang=js"
import style0 from "./AppNoRecordScreen.vue?vue&type=style&index=0&id=51046a1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51046a1e",
  null
  
)

export default component.exports